module.exports = __webpack_public_path__ + "img/afn.98a16938.svg";